import { render, staticRenderFns } from "./AppointmentAmount.vue?vue&type=template&id=926aaf9a&scoped=true&"
import script from "./AppointmentAmount.vue?vue&type=script&lang=js&"
export * from "./AppointmentAmount.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentAmount.vue?vue&type=style&index=0&id=926aaf9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926aaf9a",
  null
  
)

export default component.exports